module.exports = __webpack_public_path__ + "static/img/banner-textnew.0c3e566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-textnew.jpg
// module id = ajoM
// module chunks = 1